"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const ToolsFetch_1 = __importDefault(require("../React/Tools/ToolsFetch"));
const base = MainSetupReact_1.default.serverUrl;
function jsonOptions(method, body) {
    return {
        method,
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    };
}
/** Cienki klient API dla endpointów scrumboarda (nie pasują do wzorca RepositoryReact/CRUD). */
class ScrumboardApi {
    static async getContractStatuses() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/contractStatuses`, jsonOptions("POST", { orConditions: [] }));
    }
    static async setContractDiscussed(contractId, discussed) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/contractStatus/${contractId}`, jsonOptions("PUT", { discussed }));
    }
    static async resetDiscussed() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/contractStatuses/reset`, jsonOptions("POST"));
    }
    static async updateTaskHours(taskId, payload) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/task/${taskId}/hours`, jsonOptions("PUT", payload));
    }
    static async resetHours() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/hours/reset`, jsonOptions("POST"));
    }
    static async updateTaskStatus(taskPayload) {
        const id = taskPayload.id;
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/task/${id}/status`, jsonOptions("PUT", taskPayload));
    }
    /** Osoby scrumboardu: pracownicy ENVI + manager z configu (te same co w podsumowaniu/planowaniu). */
    static async getPersons() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/persons`, jsonOptions("GET"));
    }
    static async getPlanning() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/planning`, jsonOptions("GET"));
    }
    static async updatePlanning(personId, values) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/planning/${personId}`, jsonOptions("PUT", values));
    }
    static async getTimesSummary() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/timesSummary`, jsonOptions("GET"));
    }
    static async generateReport() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/report`, jsonOptions("POST"));
    }
    // ---- Urlopy ----
    static async getVacations(year) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacations?year=${year}`, jsonOptions("GET"));
    }
    static async getVacationWeekCounts() {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacations/weekCounts`, jsonOptions("GET"));
    }
    static async addAbsence(payload) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacation`, jsonOptions("POST", payload));
    }
    static async updateAbsence(id, payload) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacation/${id}`, jsonOptions("PUT", payload));
    }
    static async deleteAbsence(id) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacation/${id}`, jsonOptions("DELETE"));
    }
    static async setVacationLimit(personId, year, limitDays, carryoverDays, careDays, holidayDays) {
        return ToolsFetch_1.default.fetchWithRetry(`${base}scrumboard/vacationLimit/${personId}/${year}`, jsonOptions("PUT", { limitDays, carryoverDays, careDays, holidayDays }));
    }
}
exports.default = ScrumboardApi;
